

import { CastForEducationOutlined } from "@mui/icons-material";
import moment from "moment";
import duration from "moment-duration-format";


// תקרת "אחרי חצות" - עד כמה שעות בבוקר זנב שחוצה חצות עדיין נחשב שייך
// ליום הקודם. אותה קונבנציה בדיוק כמו server/_routers/tabelsOrdersRouter.js
// (הזמנת שולחנות): סגירה עד 05:00 שייכת ליום שנפתח בו, לא ליום העצמאי החדש.
const OVERNIGHT_TAIL_END_MIN = 5 * 60;

class MyDateTime {

    static getYesterday = (timeString,daysToback) => {
        return moment(timeString).subtract(daysToback, 'days').format('dddd');
    }
    
    static getDate = (timeString) => {
        return (
            moment(timeString).format('DD/MM/YYYY')
        )
    }
    static getTime = (timeString) => {
        return (
            moment(timeString).format('HH:mm:ss')
        )
    }

    static getShortTime = (timeString) => {

        return (
            moment(timeString).format('HH:mm')
        )
    }
    static getDateAndTime = (timeString) => {
        return (
            moment(timeString).format('DD/MM/YYYY HH:mm')
        )
    }

    static getDayOfWeek = (timeString) => {

        return (
            moment(timeString).format('dddd')
        )
    }
    static getDayOfWeekHeb = (timeString) => {
        switch (moment(timeString).format('dddd')) {
            case "Sunday": return "ראשון";
            case "Monday": return "שני";
            case "Tuesday": return "שלישי";
            case "Wednesday": return "רביעי";
            case "Thursday": return "חמישי";
            case "Friday": return "שישי";
            case "Saturday": return "שבת";
            default: return "";
        }

    }

    static getDayOfWeekLettersHeb = (DayName) => {
        switch (DayName) {
            case "Sunday": return "א";
            case "Monday": return "ב";
            case "Tuesday": return "ג";
            case "Wednesday": return "ד";
            case "Thursday": return "ה";
            case "Friday": return "ו";
            case "Saturday": return "ש";
            default: return "";
        }

    }

    static getDayOfWeekByDayNum = (dayNum) => {
        switch (dayNum) {
            case 1: return "Sunday";
            case 2: return "Monday";
            case 3: return "Tuesday";
            case 4: return "Wednesday";
            case 5: return "Thursday";
            case 6: return "Friday";
            case 7: return "Saturday";
            default: return "";
        }

    }

    static getDayOfWeekLettersHebByNum = (DayNum) => {
        switch (DayNum) {
            case 0: return "א";
            case 1: return "ב";
            case 2: return "ג";
            case 3: return "ד";
            case 4: return "ה";
            case 5: return "ו";
            case 6: return "ש";
          
            default: return "";
        }

    }

    // static getTimeLeftTilThen = (timeString, thenTime, showTxts) => {

    //     var thenTime = moment(timeString).add(parseInt(thenTime), 'minutes')

    //     var seconds = moment().utc(true).local('he').diff(thenTime, 'seconds')
    //     var duration = moment.duration(seconds, 'seconds');
    //     var formatted = duration.format("hh:mm:ss");

    //     var temp = moment().utc(true).local('he').diff(thenTime, 'hours')
    //     var daysOver = parseInt(parseInt(temp) / 24);
    //     var hoursLeft = (parseInt(temp) % 24)


    //     if (formatted.toString().includes("-")) {
    //         return (
    //             {
    //                 theTm: formatted.toString().replace("-", ""),
    //                 theCol: "lightGray",
    //                 theForCol: "black",
    //                 theEnd: false
    //             }
    //         )
    //     }
    //     else {
    //         if (showTxts) {
    //             return (
    //                 {
    //                     theTm: formatted + (daysOver > 0) ? formatted + " - " + daysOver + " ימים " + hoursLeft + " שעות" : formatted,
    //                     theCol: "red",
    //                     theForCol: "white",
    //                     theEnd: true
    //                 })
    //         }
    //         else {
    //             return (
    //                 {
    //                     theTm: formatted,
    //                     theCol: "red",
    //                     theForCol: "white",
    //                     theEnd: true
    //                 }
    //             )
    //         }
    //     }
    // }

    //בודק אם בתוך טווח שעות



    static getTimeLeftTilThen = (timeString, thenTime) => {

        var thenTime = moment(timeString).add(parseInt(thenTime), 'minutes')

        var seconds = moment().utc().locale('he').diff(thenTime, 'seconds')
        var duration = moment.duration(seconds, 'seconds');
        var formatted = duration.format("hh:mm:ss");

        var temp = moment().utc().locale('he').diff(thenTime, 'hours')
        var daysOver = parseInt(parseInt(temp) / 24);
        var hoursLeft = (parseInt(temp) % 24)


        if (formatted.toString().includes("-")) {
            return (
                {
                    theTm: formatted.toString().replace("-", ""),
                    theCol: "lightGray",
                    theForCol: "black",
                    theEnd: false
                }
            )
        }
        else {
            return (
                {
                    theTm: formatted + (daysOver > 0) ? formatted + " - " + daysOver + " ימים " + hoursLeft + " שעות" : formatted,
                    theCol: "red",
                    theForCol: "white",
                    theEnd: true
                }
            )
        }

    }


    /////////////////////////////////////////////////////////////////
    ////  פרימיטיבים מצומדים לשעון ישראל
    ////  המערכת עובדת בישראל בלבד - לקוח בחו"ל חייב לראות
    ////  פתוח/סגור לפי שעון ישראל ולא לפי השעון שלו.
    ////  Intl עם timeZone מטפל בשעון קיץ. אסור לקודד offset קבוע.
    ////  מיושם זהה ב-server/DTechComp/MyDateTime.js
    /////////////////////////////////////////////////////////////////

    static IL_TZ = 'Asia/Jerusalem';

    //"YYYY-MM-DD" של התאריך בישראל - מפתח להשוואת טווחי חריגות
    static getIsraelDateKey = (dt) => {
        const d = dt ? new Date(dt) : new Date();
        if (isNaN(d.getTime())) return "";
        try {
            return new Intl.DateTimeFormat('en-CA', {
                timeZone: MyDateTime.IL_TZ, year: 'numeric', month: '2-digit', day: '2-digit'
            }).format(d);
        }
        catch {
            return moment(d).format('YYYY-MM-DD');
        }
    }

    //"Sunday".."Saturday" לפי התאריך בישראל
    static getIsraelDayName = (dt) => {
        const d = dt ? new Date(dt) : new Date();
        if (isNaN(d.getTime())) return "";
        try {
            return new Intl.DateTimeFormat('en-US', {
                timeZone: MyDateTime.IL_TZ, weekday: 'long'
            }).format(d);
        }
        catch {
            return moment(d).format('dddd');
        }
    }

    //"HH:mm" של השעה בישראל
    static getIsraelNowHM = (dt) => {
        const d = dt ? new Date(dt) : new Date();
        if (isNaN(d.getTime())) return "";
        try {
            let hm = new Intl.DateTimeFormat('en-GB', {
                timeZone: MyDateTime.IL_TZ, hour: '2-digit', minute: '2-digit', hour12: false
            }).format(d);
            //חלק מגרסאות ICU מחזירות "24:00" לחצות
            if (hm.indexOf('24:') === 0) hm = '00:' + hm.split(':')[1];
            return hm;
        }
        catch {
            return moment(d).format('HH:mm');
        }
    }

    //מנרמל שעה ל-"HH:mm". מקבל גם את הפורמט החדש וגם ISO מדור קודם.
    //חשוב: הזיהוי של "HH:mm" חייב לקרות לפני כל פרסור,
    //כי new Date("09:00") מחזיר Invalid Date
    static normalizeHM = (val) => {
        if (val === null || val === undefined || val === "") return "";

        if (typeof val === "string") {
            const m = val.match(/^(\d{1,2}):(\d{2})$/);
            if (m) {
                const h = parseInt(m[1], 10);
                const mm = parseInt(m[2], 10);
                if (isNaN(h) || isNaN(mm) || h > 23 || mm > 59) return "";
                return String(h).padStart(2, '0') + ":" + m[2];
            }
        }

        const d = new Date(val);
        if (isNaN(d.getTime())) return "";
        return MyDateTime.getIsraelNowHM(d);
    }

    //פותר צד יחיד (פתיחה או סגירה) של שורת-שעות / ערוץ-חריגה מול
    //עוגני "שעת בסיס" במאסטר.
    //  fromMaster !== true              -> normalizeHM(manualHM) (הצד ידני)
    //  העוגן לא נמצא / כבוי / שעה ריקה  -> fallback ל-normalizeHM(manualHM)
    //  אחרת                            -> minutesToHM(baseTime + offset)
    //יש עותק תואם ב-server/DTechComp/MyDateTime.js - לשנות בשניהם יחד
    static resolveBaseSideHM = (fromMaster, baseId, offset, manualHM, master) => {
        const manual = MyDateTime.normalizeHM(manualHM);
        if (fromMaster !== true) return manual;

        const sets = (master && Array.isArray(master.baseHoursSets)) ? master.baseHoursSets : null;
        if (!sets) return manual;

        const set = sets.find(s => s && s.id === baseId && s.active !== false);
        if (!set) return manual;

        const base = MyDateTime.hmToMinutes(MyDateTime.normalizeHM(set.time));
        if (base === null) return manual;

        return MyDateTime.minutesToHM(base + (Number(offset) || 0));
    }

    //פותר שורת-שעות / ערוץ-חריגה מול עוגני המאסטר - פתיחה וסגירה בנפרד.
    //row: { OpenFromMaster, OpenBaseId, OpenOffset, CloseFromMaster,
    //     CloseBaseId, CloseOffset, Open, Close, Closed }.
    //החזרה: { Open, Close, Closed, Break }.
    //Break = { From, To } או null (ר' rowBreak). לערוץ-חריגה אין Break, ולכן
    //ביום חריג ההפסקה הרגילה לא חלה.
    //יש עותק תואם ב-server/DTechComp/MyDateTime.js - לשנות בשניהם יחד
    static resolveRowHM = (row, master) => {
        if (!row) return { Open: "", Close: "", Closed: true, Break: null };

        const open = MyDateTime.resolveBaseSideHM(row.OpenFromMaster, row.OpenBaseId, row.OpenOffset, row.Open, master);
        const close = MyDateTime.resolveBaseSideHM(row.CloseFromMaster, row.CloseBaseId, row.CloseOffset, row.Close, master);

        return {
            Open: open,
            Close: close,
            Closed: row.Closed === true || (open === "" && close === ""),
            Break: MyDateTime.rowBreak(row)
        };
    }

    //ההפסקה של שורת יום: { From, To } או null.
    //null כשכבויה, כשאחד הצדדים לא "HH:mm" תקין, או כשהצדדים שווים
    static rowBreak = (row) => {
        const br = row ? row.Break : null;
        if (!br || br.Active !== true) return null;
        const from = MyDateTime.normalizeHM(br.From);
        const to = MyDateTime.normalizeHM(br.To);
        if (MyDateTime.hmToMinutes(from) === null || MyDateTime.hmToMinutes(to) === null || from === to) return null;
        return { From: from, To: to };
    }

    //ההפסקה על ציר הטווח: דקות מהפתיחה [from, to], או null כשאין
    //הפסקה תקינה בתוך הטווח. עובד גם לטווח שעובר חצות (17:00-03:00 עם
    //הפסקה 00:30-01:00), כי הכל נמדד מהפתיחה במעגל של 1440.
    //הפסקה שחוצה את שעת הפתיחה, או שלא נכנסת בטווח -> null (מתעלמים)
    static breakSpan = (eff) => {
        const br = eff ? eff.Break : null;
        if (!br) return null;
        const o = MyDateTime.hmToMinutes(eff.Open);
        const c = MyDateTime.hmToMinutes(eff.Close);
        const f = MyDateTime.hmToMinutes(br.From);
        const t = MyDateTime.hmToMinutes(br.To);
        if (o === null || c === null || f === null || t === null) return null;

        const rel = (m) => (((m - o) % 1440) + 1440) % 1440;
        let len = rel(c);
        if (len === 0) len = 1440;
        const rf = rel(f);
        const rt = rel(t);
        if (!(rf > 0 && rt > rf && rt < len)) return null;
        return [rf, rt];
    }

    //האם nowMin (דקות מתחילת היום) בתוך ההפסקה של הטווח eff.
    //אותה סמנטיקה כמו הפתיחה: (from, to] - בדקה של "From" עוד פתוח,
    //בדקה של "To" עדיין סגור. ב-checkChannel ההשוואה לפתיחה היא nowMin > o
    static isInBreak = (eff, nowMin) => {
        const span = MyDateTime.breakSpan(eff);
        if (!span || nowMin === null) return false;
        const o = MyDateTime.hmToMinutes(eff.Open);
        const n = (((nowMin - o) % 1440) + 1440) % 1440;
        return n > span[0] && n <= span[1];
    }

    //הקטעים להצגה: [[Open, From], [To, Close]] כשיש הפסקה תקינה, אחרת [[Open, Close]]
    static hoursSegments = (eff) => {
        if (MyDateTime.breakSpan(eff)) return [[eff.Open, eff.Break.From], [eff.Break.To, eff.Close]];
        return [[eff.Open, eff.Close]];
    }

    //מתאים את ההפסקה של hrs לטווח החתוך inter (שנמצא בתוך hrs).
    //הכל נמדד מהפתיחה של hrs, ולכן עובד גם לטווח שעובר חצות:
    //  ההפסקה בתוך inter          -> נשארת
    //  ההפסקה מכסה את תחילת inter -> הפתיחה זזה לסוף ההפסקה
    //  ההפסקה מכסה את סוף inter   -> הסגירה זזה לתחילת ההפסקה
    //  ההפסקה מכסה את כל inter     -> null (סגור)
    //  ההפסקה מחוץ ל-inter        -> אין הפסקה
    static clipBreakToRange = (hrs, inter) => {
        const span = MyDateTime.breakSpan(hrs);
        if (!span) return { Open: inter.Open, Close: inter.Close, Break: null };

        const o = MyDateTime.hmToMinutes(hrs.Open);
        const rel = (hm) => (((MyDateTime.hmToMinutes(hm) - o) % 1440) + 1440) % 1440;
        const s = rel(inter.Open);
        let e = rel(inter.Close);
        if (e <= s) e += 1440;

        const [bf, bt] = span;
        if (bt <= s || bf >= e) return { Open: inter.Open, Close: inter.Close, Break: null };
        if (bf <= s && bt >= e) return null;
        if (bf <= s) return { Open: hrs.Break.To, Close: inter.Close, Break: null };
        if (bt >= e) return { Open: inter.Open, Close: hrs.Break.From, Break: null };
        return { Open: inter.Open, Close: inter.Close, Break: hrs.Break };
    }

    //שולף את שעות היום לערוץ מסוים.
    //TakeAwayHours חסר -> נופל ל-OpeningHours (fallback המיגרציה).
    //ברמת המערך בלבד, לעולם לא ברמת שורה - אחרת אי אפשר לבטא
    //"העסק פתוח בשישי אבל אין איסופים בשישי"
    //master דרוש לפתרון צדדים שמסומנים FromMaster (resolveRowHM)
    static getChannelHours = (item, channelKey, dayName, master) => {
        let arr = item ? item[channelKey] : null;

        if (channelKey === 'TakeAwayHours' && !(Array.isArray(arr) && arr.length > 0)) {
            arr = item ? item.OpeningHours : null;
        }
        if (!Array.isArray(arr)) return { Open: "", Close: "", Closed: true };

        const idx = arr.findIndex(dy => dy && (dy.Day || "").toString() === dayName.toString());
        if (idx < 0) return { Open: "", Close: "", Closed: true };

        const res = MyDateTime.resolveRowHM(arr[idx], master);

        //שעות ההזמנות העתידיות הן תת-טווח של שעות הערוץ, ולכן ההפסקה של
        //הערוץ חלה גם עליהן (לא נערכת בנפרד)
        const srcKey = MyDateTime.FUTURE_HOURS_SOURCE[channelKey];
        if (srcKey && !res.Closed && res.Open !== "" && res.Close !== "") {
            const src = MyDateTime.getChannelHours(item, srcKey, dayName, master);
            if (!src.Closed && src.Break) {
                const clipped = MyDateTime.clipBreakToRange(src, res);
                if (!clipped) return { Open: "", Close: "", Closed: true, Break: null };
                return { ...res, Open: clipped.Open, Close: clipped.Close, Break: clipped.Break };
            }
        }

        return res;
    }

    static FUTURE_HOURS_SOURCE = {
        futureOrdersDeliveryHours: 'DeliveryHours',
        futureOrdersTakeAwayHours: 'TakeAwayHours'
    };

    //"YYYY-MM-DD" -> היום שלפניו. חשבון על UTC בצהריים, ולכן חסין
    //למעברי שעון קיץ
    static prevDateKey = (dateKey) => {
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');
        if (!m) return "";
        const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12));
        d.setUTCDate(d.getUTCDate() - 1);
        return d.getUTCFullYear() + '-' +
            String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
            String(d.getUTCDate()).padStart(2, '0');
    }

    //"YYYY-MM-DD" -> "Sunday".."Saturday". חישוב על UTC, בלי timezone
    static dayNameOfDateKey = (dateKey) => {
        const names = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');
        if (!m) return "";
        return names[new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12)).getUTCDay()];
    }

    //בונה את אובייקט התוצאה.
    //
    //eff הוא הטווח שרלוונטי להצגה: כשפתוח - הטווח *הפעיל* (שיכול להיות
    //של אתמול, אם אנחנו בזנב שאחרי חצות), וכשסגור - הטווח של היום,
    //כי זו האינפורמציה שמעניינת את הלקוח ("סגור, נפתח ב-11:00").
    //
    //הטקסטים נגזרים מהטווח האמיתי ולא מהחלון המחושב, כדי שיוצג
    //"11:00-02:00" ולא "11:00-23:59"
    //
    //inBreak - סגור כי אנחנו בתוך ההפסקה של הטווח (eff.Break). נפתח שוב ב-Break.To
    //
    //timtxt הפוך ("Close - Open") בשביל התצוגה מימין לשמאל. עם הפסקה
    //שני הקטעים הפוכים גם הם, כך שהסדר המוצג נשאר מהבוקר לערב
    static buildHoursRes = (openNow, eff, fromYesterday, inBreak) => {
        const noHours = eff.Closed || eff.Open === "" || eff.Close === "";

        if (noHours) {
            return {
                openOrCLose: openNow, open: openNow,
                txtBtn: openNow ? "פתוח" : "סגור היום",
                timtxt: "00:00 - 00:00",
                source: eff.source, excName: eff.excName,
                hours: { Open: "", Close: "", Break: null },
                inBreak: false, reopenAt: null,
                fromYesterday: !!(openNow && fromYesterday)
            };
        }

        const segs = MyDateTime.hoursSegments(eff);
        const brk = segs.length > 1 ? eff.Break : null;
        const rangeTxt = segs.map(sg => sg[0] + "-" + sg[1]).join(", ");
        const breakNow = !!(!openNow && inBreak && brk);

        return {
            openOrCLose: openNow, open: openNow,
            txtBtn: openNow
                ? "פתוח ( " + rangeTxt + " )"
                : breakNow
                    ? "סגור להפסקה (נפתח ב-" + brk.To + ")"
                    : (eff.Open !== "00:00" ? "סגור (" + rangeTxt + ")" : "סגור היום"),
            timtxt: segs.map(sg => sg[1] + " - " + sg[0]).reverse().join(" , "),
            source: eff.source, excName: eff.excName,
            hours: { Open: eff.Open, Close: eff.Close, Break: brk },
            inBreak: breakNow,
            reopenAt: breakNow ? brk.To : null,
            fromYesterday: !!(openNow && fromYesterday)
        };
    }

    //"HH:mm" -> דקות מתחילת היום. לא תקין -> null
    static hmToMinutes = (hm) => {
        const m = /^(\d{1,2}):(\d{2})$/.exec(hm || '');
        if (!m) return null;
        const h = parseInt(m[1], 10), mm = parseInt(m[2], 10);
        if (isNaN(h) || isNaN(mm) || h > 23 || mm > 59) return null;
        return h * 60 + mm;
    }

    //דקות -> "HH:mm". עוטף מעל 24 שעות
    static minutesToHM = (min) => {
        const v = ((Math.round(min) % 1440) + 1440) % 1440;
        return String(Math.floor(v / 60)).padStart(2, '0') + ':' + String(v % 60).padStart(2, '0');
    }

    //חיתוך שני טווחי שעות. מחזיר { Open, Close } או null כשאין חפיפה.
    //
    //עובד בדקות על ציר ישר: טווח שבו הסגירה קטנה או שווה לפתיחה נחשב
    //כעובר חצות, ולכן מקבל +1440. כדי לטפל בשעון המעגלי, הטווח השני
    //נבדק גם מוזז ב-1440 לשני הכיוונים, ונבחרת החפיפה הארוכה ביותר.
    //
    //מגבלה מוכרת ומכוונת: על שעון מעגלי החיתוך יכול להיות *שני* קטעים
    //נפרדים, ומבנה של Open/Close אחד מחזיק רק אחד מהם. למשל
    //מסגרת 22:00-02:00 מול שעות 01:00-23:00 -> החפיפה האמיתית היא
    //01:00-02:00 וגם 22:00-23:00, ומוחזר רק הקטע הארוך/הראשון.
    //התרחיש דורש מסגרת שעוברת חצות וגם עסק שפתוח מעל 20 שעות ביום,
    //ולכן הוחלט לא לתמוך בשני קטעים. ההתנהגות דטרמיניסטית וזהה בין
    //הלקוח לשרת, כי סדר הקריאה תמיד (מאסטר, עסק).
    static intersectHM = (aOpen, aClose, bOpen, bClose) => {
        const toSpan = (o, c) => {
            const s = MyDateTime.hmToMinutes(o);
            let e = MyDateTime.hmToMinutes(c);
            if (s === null || e === null) return null;
            //סגירה <= פתיחה -> הסגירה למחרת. שווים -> 24 שעות
            if (e <= s) e += 1440;
            return [s, e];
        };

        const A = toSpan(aOpen, aClose);
        const B = toSpan(bOpen, bClose);
        if (!A || !B) return null;

        //טווח של יממה שלמה (Open === Close) לא מגביל כלום, ולכן החיתוך
        //הוא פשוט הטווח השני. בלי הקיצור הזה החלוקה של המעגל לציר ישר
        //הייתה מחזירה תוצאה שתלויה בסדר הפרמטרים
        const aFull = A[1] - A[0] >= 1440;
        const bFull = B[1] - B[0] >= 1440;
        if (aFull && bFull) return { Open: "00:00", Close: "23:59" };
        if (aFull) return { Open: MyDateTime.minutesToHM(B[0]), Close: MyDateTime.minutesToHM(B[1]) };
        if (bFull) return { Open: MyDateTime.minutesToHM(A[0]), Close: MyDateTime.minutesToHM(A[1]) };

        let best = null;
        for (const shift of [-1440, 0, 1440]) {
            const s = Math.max(A[0], B[0] + shift);
            const e = Math.min(A[1], B[1] + shift);
            if (e > s && (!best || (e - s) > (best[1] - best[0]))) best = [s, e];
        }
        if (!best) return null;

        return { Open: MyDateTime.minutesToHM(best[0]), Close: MyDateTime.minutesToHM(best[1]) };
    }

    //השעות האפקטיביות לערוץ בתאריך נתון - הכלל המרכזי, במקום אחד.
    //
    //   המאסטר מגדיר מסגרת. העסק יכול רק לצמצם בתוכה.
    //
    //   התוצאה היא החפיפה בין מסגרת המאסטר לשעות העסק:
    //   - "סגור" מכל אחד מהצדדים  -> סגור
    //   - חפיפה ריקה              -> סגור. אין כפייה על עסק לפתוח
    //                                בשעות שהוא לא הגדיר
    //   - אין חריגת מאסטר         -> שעות העסק כמו שהן
    //
    //   שעות העסק עצמן הן חריגת העסק אם קיימת, ואחרת שורת יום השבוע.
    //
    //מיושם זהה ב-server/DTechComp/MyDateTime.js
    static effectiveChannelHours = (item, master, channelKey, dateKey, dayName) => {
        const buisList = item ? item.dateSpecilsBlocks : null;
        const mastList = master ? master.dateSpecilsBlocks : null;

        //---- שעות העסק ----
        const bExc = MyDateTime.findActiveException(buisList, channelKey, dateKey);
        let hrs, source, excName = null;

        if (bExc) {
            source = 'exception';
            excName = bExc.exc.name || null;
            //פתיחה/סגירה של ערוץ החריגה יכולות להיות צמודות לעוגן מאסטר
            hrs = MyDateTime.resolveRowHM(bExc.ch, master);
        }
        else {
            source = 'regular';
            hrs = MyDateTime.getChannelHours(item, channelKey, dayName, master);
        }

        //העסק סגור - סוף פסוק. המאסטר לא יכול להכריח אותו לפתוח
        if (hrs.Closed || hrs.Open === "" || hrs.Close === "") {
            return { Open: "", Close: "", Closed: true, source, excName };
        }

        //---- מסגרת המאסטר ----
        const mExc = MyDateTime.findActiveException(mastList, channelKey, dateKey);
        if (!mExc) {
            return { Open: hrs.Open, Close: hrs.Close, Closed: false, Break: hrs.Break || null, source, excName };
        }

        const mName = mExc.exc.name || null;

        //מסגרת המאסטר יכולה גם היא להיות צמודה לעוגן מאסטר (פתיחה/סגירה בנפרד)
        const mResolved = MyDateTime.resolveRowHM(mExc.ch, master);

        if (mResolved.Closed === true) {
            return { Open: "", Close: "", Closed: true, source: 'masterException', excName: mName };
        }

        const mOpen = mResolved.Open;
        const mClose = mResolved.Close;

        //מסגרת בלי שעות תקינות - מתעלמים ממנה ולא סוגרים בגללה
        if (mOpen === "" || mClose === "") {
            return { Open: hrs.Open, Close: hrs.Close, Closed: false, Break: hrs.Break || null, source, excName };
        }

        const inter = MyDateTime.intersectHM(mOpen, mClose, hrs.Open, hrs.Close);
        if (!inter) {
            return { Open: "", Close: "", Closed: true, source: 'masterException', excName: mName };
        }

        //ההפסקה של העסק נשארת בתוקף גם בתוך מסגרת המאסטר
        const clipped = MyDateTime.clipBreakToRange(hrs, inter);
        if (!clipped) {
            return { Open: "", Close: "", Closed: true, source: 'masterException', excName: mName };
        }

        return { Open: clipped.Open, Close: clipped.Close, Closed: false, Break: clipped.Break, source: 'masterException', excName: mName };
    }

    //מספר הימים בין שני מפתחות תאריך. לחישוב רוחב הטווח בלבד
    static dateKeySpan = (fromKey, toKey) => {
        const a = Date.parse(fromKey + "T00:00:00Z");
        const b = Date.parse(toKey + "T00:00:00Z");
        if (isNaN(a) || isNaN(b)) return Number.MAX_SAFE_INTEGER;
        return Math.round((b - a) / 86400000);
    }

    //מוצא יום חריג פעיל לערוץ מסוים בתאריך נתון.
    //
    //קדימות בחפיפה: הטווח הצר מנצח. כך חריגה של יום בודד
    //("יום כיפור") גוברת על חריגת טווח ארוך שמכילה אותה ("פסח").
    //שוברי שוויון: createdAt מאוחר יותר, ואז אינדקס מאוחר יותר.
    static findActiveException = (list, channelKey, dateKey) => {
        if (!Array.isArray(list) || !dateKey) return null;

        let best = null;

        for (let i = 0; i < list.length; i++) {
            const exc = list[i];
            if (!exc || exc.active === false) continue;
            if (!exc.fromDate) continue;

            const to = exc.toDate || exc.fromDate;
            if (!(exc.fromDate <= dateKey && dateKey <= to)) continue;

            const ch = exc.channels ? exc.channels[channelKey] : null;
            if (!ch) continue;

            const span = MyDateTime.dateKeySpan(exc.fromDate, to);
            const createdAt = exc.createdAt || "";

            if (best === null ||
                span < best.span ||
                (span === best.span && createdAt > best.createdAt) ||
                (span === best.span && createdAt === best.createdAt && i > best.index)) {
                best = { exc, ch, span, createdAt, index: i };
            }
        }

        return best;
    }

    //בודק ערוץ בודד מול שעון ישראל, כולל ימים חריגים.
    //
    //קדימות: Closed מאחת הרמות מנצח; אחרת שעות של העסק מנצחות
    //שעות גלובליות; אחרת שעות יום השבוע הרגילות.
    static checkChannel = (item, channelKey, now, master) => {
        try {
            const dt = now ? new Date(now) : new Date();
            const dayName = MyDateTime.getIsraelDayName(dt);
            const nowHM = MyDateTime.getIsraelNowHM(dt);
            const dateKey = MyDateTime.getIsraelDateKey(dt);

            const buisList = item ? item.dateSpecilsBlocks : null;
            const mastList = master ? master.dateSpecilsBlocks : null;

            const closedRes = (source, excName) => ({
                openOrCLose: false,
                txtBtn: "סגור היום",
                timtxt: "00:00 - 00:00",
                open: false,
                source: source,
                excName: excName || null
            });

            //-------- מפסק החירום --------
            //חריגה על שעות הפתיחה שמסומנת "סגור" הורגת את שלושת
            //הערוצים. שים לב לא-סימטריה: שעות פתיחה *רגילות* לא
            //חוסמות הזמנות בכלל, אבל *חריגה* מסומנת סגור כן.
            //"סגור" מכל אחת מהרמות סוגר
            if (channelKey !== 'OpeningHours') {
                const mKill = MyDateTime.findActiveException(mastList, 'OpeningHours', dateKey);
                if (mKill && mKill.ch.Closed === true) {
                    const r = closedRes('masterException', mKill.exc.name);
                    r.blockedByOpening = true;
                    return r;
                }
                const bKill = MyDateTime.findActiveException(buisList, 'OpeningHours', dateKey);
                if (bKill && bKill.ch.Closed === true) {
                    const r = closedRes('exception', bKill.exc.name);
                    r.blockedByOpening = true;
                    return r;
                }
            }

            //-------- שעות אפקטיביות: חיתוך מסגרת המאסטר עם שעות העסק --------
            const todayEff = MyDateTime.effectiveChannelHours(item, master, channelKey, dateKey, dayName);

            //שורת אתמול, בשביל זנב שעובר חצות.
            //
            //זה הלב של החישוב: טווח שבו הסגירה קטנה מהפתיחה (למשל
            //11:00-02:00) נגמר *מחר*, ולכן החלק שלו שנכנס להיום הוא רק
            //מהפתיחה עד סוף היום. את השעות הקטנות של היום מכסה דווקא
            //שורת *אתמול*, אם היא זו שעוברת חצות.
            //
            //בלי ההפרדה הזו, עסק שפתוח שלישי 11:00-02:00 היה נראה פתוח
            //בשלישי ב-00:40 - למרות שהזנב הזה שייך לרביעי, ואת שלישי
            //בבוקר מכסה שורת שני שנגמרה כבר ב-00:30.
            const yKey = MyDateTime.prevDateKey(dateKey);
            const yEff = MyDateTime.effectiveChannelHours(
                item, master, channelKey, yKey, MyDateTime.dayNameOfDateKey(yKey));

            const nowMin = MyDateTime.hmToMinutes(nowHM);
            let openNow = false;
            //הטווח הפעיל - זה שבתוכו אנחנו נמצאים. כשסגור, מציגים
            //את הטווח של היום
            let activeEff = todayEff;
            let openedFromYesterday = false;

            //החלק של היום
            if (!todayEff.Closed && nowMin !== null) {
                const o = MyDateTime.hmToMinutes(todayEff.Open);
                const c = MyDateTime.hmToMinutes(todayEff.Close);
                if (o !== null && c !== null && !(o === 0 && c === 0)) {
                    openNow = (c > o) ? (nowMin > o && nowMin <= c) : (nowMin > o);
                }
            }

            //הזנב של אתמול. רלוונטי גם כשהיום עצמו מוגדר סגור: יום עסקים
            //שהתחיל אתמול בערב נמשך אל תוך הבוקר, ו"סגור היום" אומר
            //שלא מתחיל יום עסקים חדש - לא שסוגרים באמצע השירות בחצות
            if (!openNow && !yEff.Closed && nowMin !== null) {
                const yo = MyDateTime.hmToMinutes(yEff.Open);
                const yc = MyDateTime.hmToMinutes(yEff.Close);
                if (yo !== null && yc !== null && yc <= yo && !(yo === 0 && yc === 0)) {
                    if (nowMin > 0 && nowMin <= yc) {
                        openNow = true;
                        activeEff = yEff;
                        openedFromYesterday = true;
                    }
                }
            }

            //ההפסקה של הטווח הפעיל: בתוכה הערוץ סגור, ומציגים את הטווח
            //הפעיל (בשביל "נפתח ב-") ולא את הטווח של היום
            let inBreak = false;
            if (openNow && MyDateTime.isInBreak(activeEff, nowMin)) {
                openNow = false;
                inBreak = true;
            }

            return MyDateTime.buildHoursRes(openNow, (openNow || inBreak) ? activeEff : todayEff, openedFromYesterday, inBreak);
        }
        catch {
            return {
                openOrCLose: false, txtBtn: "סגור", timtxt: "00:00 - 00:00",
                open: false, source: 'regular', excName: null
            };
        }
    }

    static checkIfBetweenHours = (item, master, now) => {
        return MyDateTime.checkChannel(item, 'OpeningHours', now, master);
    }

    static checkIfBetweenDeliveryHours = (item, master, now) => {
        return MyDateTime.checkChannel(item, 'DeliveryHours', now, master);
    }

    static checkIfBetweenTakeAwayHours = (item, master, now) => {
        return MyDateTime.checkChannel(item, 'TakeAwayHours', now, master);
    }

    //שלושת הערוצים בקריאה אחת + האם אפשר להזמין עכשיו.
    //
    //business  - התווית "פתוח/סגור" בדף העסק. לא חוסם הזמנות.
    //takeAwayOk / deliveryOk - האם הכפתור של הערוץ נפתח: שעות
    //  הערוץ + Doing + אין השהיה + לא חסום במאסטר (+ ערי משלוח).
    //canOrderNow - לפי זה נקבע המיון והרשימות "פתוחים עכשיו",
    //  ולא לפי התווית. עסק יכול להיות "פתוח" ובלי אפשרות להזמין.
    static resolveBusinessChannels = (item, master = {}, now = new Date()) => {
        const business = MyDateTime.checkIfBetweenHours(item, master, now);
        const takeAway = MyDateTime.checkIfBetweenTakeAwayHours(item, master, now);
        const delivery = MyDateTime.checkIfBetweenDeliveryHours(item, master, now);

        //בודק את closeTakeDelay ולא את closeDeliverDelay -
        //היו כאן שלושה אתרים שבדקו את השדה הלא נכון
        const takeAwayOk = !!(takeAway.openOrCLose &&
            item && item.TakeAway && item.TakeAway.Doing &&
            (!item.closeTakeDelay || item.closeTakeDelay.delaydVal === "0") &&
            !(master && master.blockPickUps && master.blockPickUps.block));

        const deliveryOk = !!(delivery.openOrCLose &&
            item && item.Delivery && item.Delivery.Doing &&
            (!item.closeDeliverDelay || item.closeDeliverDelay.delaydVal === "0") &&
            !(master && master.blockDeliverys && master.blockDeliverys.block) &&
            Array.isArray(item.cityesToDeliver) && item.cityesToDeliver.length > 0);

        return {
            business, takeAway, delivery,
            takeAwayOk, deliveryOk,
            canOrderNow: takeAwayOk || deliveryOk
        };
    }

    //נשמר עבור אתרי הקריאה הקיימים. normalizeHM מקבל
    //גם ISO מדור קודם וגם "HH:mm" חדש
    static checkIt = (tmToCheck, startHu, endHu) => {
        return MyDateTime.checkHM(
            MyDateTime.getIsraelNowHM(tmToCheck),
            MyDateTime.normalizeHM(startHu),
            MyDateTime.normalizeHM(endHu)
        );
    }

    //אותו אלגוריתם, אבל על "HH:mm" מנורמלים.
    //"00:00"-"00:00" נשאר "סגור" כ-fallback לנתונים שלא עברו מיגרציה.
    //שעות ריקות -> סגור (מיושר עם השרת. בטוח כי OpeningHours
    //לא חוסם יותר הזמנות - הערוצים עושים את זה)
    //
    //אזהרה: אל תשתמש בזה לחישוב פתוח/סגור. הפונקציה מקבלת טווח בודד
    //ולכן לא יכולה לדעת לאיזה *יום* שייך זנב שעובר חצות. עסק שפתוח
    //שלישי 11:00-02:00 ייראה כאן פתוח בשלישי ב-00:40, למרות שהזנב
    //הזה שייך לרביעי. השתמש ב-checkChannel, שמצליב את שורת היום עם
    //שורת אתמול. הפונקציה נשמרת רק בשביל checkIt מדור קודם.
    static checkHM = (tm, bef, aft) => {

        let openTxt = "פתוח";
        let closeTxt = "סגור";

        if (bef != "" && aft != "") {
            ///סגור
            if (bef == "00:00" &&
                aft == "00:00") {
                return {
                    openOrCLose: false, txtBtn: closeTxt
                }
            }
            ///שעת סגירה גדול משעת פתיחה 
            //- המקום סוגר לפני 12 בלילה
            if (aft > bef) {
                //השעה הנוכחית גדולה משעת הסגירה
                if (tm > aft) {
                    return {
                        openOrCLose: false,
                        txtBtn: (bef != "00:00") ? closeTxt + " (" + bef + ")" : closeTxt + " היום",
                        timtxt: aft + " - " + bef
                    };
                }
                else {

                    if (tm > bef) {
                        return {
                            openOrCLose: true,
                            txtBtn: openTxt + " ( " + bef + "-" + aft + " )",
                            timtxt: aft + " - " + bef
                        };
                    }
                    else {
                        return {
                            openOrCLose: false,
                            txtBtn: (bef != "00:00") ? closeTxt + " (" + bef + ")" : closeTxt + " היום",
                            timtxt: aft + " - " + bef
                        };
                    }

                }
            }
            ///שעת סגירה קטן משעת פתיחה 
            //- המקום סוגר אחרי 12 בלילה
            else if (tm < bef && tm > aft) {

                return {
                    openOrCLose: false,
                    txtBtn: (bef != "00:00") ? closeTxt + " (" + bef + ")" : closeTxt + " היום",
                    timtxt: aft + " - " + bef
                };
            }
            else {
                return {
                    openOrCLose: true,
                    txtBtn: openTxt + " ( " + bef + "-" + aft + " )",
                    timtxt: aft + " - " + bef
                };

            }

        }
        else {
            return {
                openOrCLose: true,
                txtBtn: openTxt + " (" + bef + ":" + aft + ")",
                timtxt: aft + " - " + bef
            };
        }

    }

    // יש עותק תואם ב-server/DTechComp/MyDateTime.js - לשנות בשניהם יחד.
    // בודק אם slot עתידי מבוקש חוקי לערוץ נתון: מעבר ל-lead time המינימלי (שעתיים),
    // בתוך טווח הימים המותר (אם הוגדר per-business), מופעל ע"י העסק/מאסטר לערוץ הזה,
    // ובתוך שעות הפתיחה בפועל (כולל ימים חריגים) - דרך resolveBusinessChannels הקיים
    // שכבר מקבל now שרירותי.
    static MIN_FUTURE_LEAD_MINUTES = 120;
    static isFutureSlotValid = (rest, master, requestedDate, channel /* "Deliver"|"Take" */) => {
        const now = new Date();
        const leadOk = (requestedDate.getTime() - now.getTime()) >= MyDateTime.MIN_FUTURE_LEAD_MINUTES * 60 * 1000;
        if (!leadOk) return { ok: false, reason: 'leadTime' };

        if (rest && rest.futureOrdersMaxDaysAhead != null) {
            const maxDate = new Date(now.getTime() + rest.futureOrdersMaxDaysAhead * 24 * 60 * 60 * 1000);
            if (requestedDate.getTime() > maxDate.getTime()) return { ok: false, reason: 'tooFarAhead' };
        }

        if (master && master.masterFutureOrders && master.masterFutureOrders.block) {
            return { ok: false, reason: 'masterBlocked' };
        }
        if (!rest || !rest.futureOrdersEnabled) return { ok: false, reason: 'disabledForBusiness' };
        //ברירת המחדל בסכמה היא true - מסמכים ישנים שנוצרו לפני הוספת השדה
        //עשויים להיות undefined ולא false, ולכן !== false ולא בדיקת אמת ישירה
        if (channel === 'Deliver' && rest.futureOrdersDelivery === false) return { ok: false, reason: 'channelNotSupported' };
        if (channel === 'Take' && rest.futureOrdersTakeAway === false) return { ok: false, reason: 'channelNotSupported' };

        // בדיקת השהיה (CloseDelay) לא נעשית דרך resolveBusinessChannels כאן בכוונה:
        // הבדיקה שם היא שטוחה (delaydVal!=="0" => חסום תמיד, בלי קשר לזמן), נכון לבדיקת
        // "עכשיו" אך שגוי עבור slot עתידי. "עד שנפתח שוב" (8) חוסם את כל העתיד; השהיה
        // עם משך (delayCnt=חותמת זמן מוחלטת) חוסמת רק slots שלפני תום ההשהיה.
        const delayObj = (channel === 'Deliver') ? rest.closeDeliverDelay : rest.closeTakeDelay;
        let blockedByDelay = false;
        if (delayObj && delayObj.delaydVal && delayObj.delaydVal !== "0") {
            if (delayObj.delaydVal === "8") {
                blockedByDelay = true;
            } else if (delayObj.delayCnt) {
                blockedByDelay = requestedDate.getTime() < new Date(delayObj.delayCnt).getTime();
            } else {
                blockedByDelay = true;
            }
        }
        if (blockedByDelay) return { ok: false, reason: 'temporarilyClosed' };

        //שעות מותאמות להזמנות עתידיות (per-channel) - זהה ללוגיקה בשרת
        //(server/DTechComp/MyDateTime.js::isFutureSlotValid), חייב להישאר מסונכרן.
        //אין דגל נפרד - קיום הטבלה futureOrdersDeliveryHours/futureOrdersTakeAwayHours
        //הוא הדגל; עסק שמעולם לא שמר טבלה כזו נופל אוטומטית לשעות הרגילות
        const customHoursKey = channel === 'Deliver' ? 'futureOrdersDeliveryHours' : 'futureOrdersTakeAwayHours';
        const hasCustomHours = Array.isArray(rest[customHoursKey]) && rest[customHoursKey].length > 0;

        const channelHours = hasCustomHours
            ? MyDateTime.checkChannel(rest, customHoursKey, requestedDate, master)
            : (channel === 'Deliver'
                ? MyDateTime.checkIfBetweenDeliveryHours(rest, master, requestedDate)
                : MyDateTime.checkIfBetweenTakeAwayHours(rest, master, requestedDate));
        const doingFlag = (channel === 'Deliver') ? !!(rest.Delivery && rest.Delivery.Doing) : !!(rest.TakeAway && rest.TakeAway.Doing);
        const masterBlock = (channel === 'Deliver')
            ? !!(master && master.blockDeliverys && master.blockDeliverys.block)
            : !!(master && master.blockPickUps && master.blockPickUps.block);
        const cityOk = (channel === 'Deliver')
            ? (Array.isArray(rest.cityesToDeliver) && rest.cityesToDeliver.length > 0)
            : true;

        const ok = !!(channelHours.openOrCLose && doingFlag && !masterBlock && cityOk);
        return ok ? { ok: true, fromYesterday: !!channelHours.fromYesterday } : { ok: false, reason: 'outOfHours' };
    };

    // יש עותק תואם ב-server/DTechComp/MyDateTime.js - לשנות בשניהם יחד.
    // מייצר את רשימת ה-slots הזמינים (קפיצות 15 דק') לתאריך נתון + ערוץ, לשימוש
    // בבניית ה-UI של בורר השעה (FutureOrderPicker).
    //
    // עסק שחוצה חצות (למשל Open="12:00" Close="03:00") ממשיך את יום העסקים שלו
    // אל תוך הבוקר של המחר - בלי הרחבה הזו, ה-slots של 00:00-03:00 היו נבדקים
    // רק כשמבקשים slots ל"מחר" (יום עצמאי משלהם), ולעולם לא כשמבקשים "היום".
    // הלולאה ממשיכה לסרוק גם 00:00..05:00 של היום שאחרי dateOnly, ומחזירה כל
    // slot עם afterMidnight כדי שה-UI יוכל לצייר קו מפריד.
    //
    // afterMidnight לא נקבע רק ע"י הזנב שהלולאה הזו מוסיפה בעצמה - גם שעות
    // קטנות שנשאלות *ישירות* בתוך dateOnly עצמו יכולות להיות בפועל זנב
    // שממשיך את הפתיחה של יום קודם (fromYesterday שמוחזר מ-isFutureSlotValid),
    // ולא שעות עצמאיות של dateOnly. בלי הבדיקה הזו, פתיחה מחדש של הבורר על
    // slot כזה הייתה מציגה אותו כשעה "רגילה", בלי המפריד המקווקו.
    static generateFutureSlots = (rest, master, dateOnly /* Date, יום שלם */, channel) => {
        const slots = [];
        const dayStart = new Date(dateOnly);
        dayStart.setHours(0, 0, 0, 0);
        for (let m = 0; m < 24 * 60; m += 15) {
            const slot = new Date(dayStart.getTime() + m * 60 * 1000);
            const check = MyDateTime.isFutureSlotValid(rest, master, slot, channel);
            if (check.ok) {
                slots.push({ time: slot, afterMidnight: !!check.fromYesterday });
            }
        }
        for (let m = 0; m <= OVERNIGHT_TAIL_END_MIN; m += 15) {
            const slot = new Date(dayStart.getTime() + (24 * 60 + m) * 60 * 1000);
            if (MyDateTime.isFutureSlotValid(rest, master, slot, channel).ok) {
                slots.push({ time: slot, afterMidnight: true });
            }
        }
        return slots;
    };

}
export default MyDateTime;
